import $ from 'jquery';

$(() => {
    $('.js-main-nav-toggle, .main-nav nav').on('click', () => {
        $("html").toggleClass("show-nav");
    });
});